import PropTypes from 'prop-types';
import styles from './Product.module.css';
import { generateThumbnail } from '../../../Helpers/ThumbHelper';

export default function Product({
    id,
    specifier,
    decalID,
    focus = 500,
    size = "256",
    title,
    description,
    onSelect,
    isActive = false,
    series
}) {
    return (
        <li 
            className={`${styles.product} ${isActive ? styles.active : ''}`} 
            data-id={id} 
            onClick={() => onSelect(id)}
        >
            <div className={styles.imgWrapper}>
                <img 
                    loading='lazy' 
                    src={generateThumbnail(id, specifier, size, focus, series, decalID)} 
                    alt={`${title} - ${description}`} 
                />
            </div>
            <div className={styles.productInfo}>
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>{description}</div>
            </div>
        </li>
    );
}

Product.propTypes = {
    id: PropTypes.number.isRequired,
    specifier: PropTypes.string.isRequired,
    decalID: PropTypes.string,
    focus: PropTypes.number,
    size: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    series: PropTypes.string.isRequired,
};